import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="comments"
export default class extends Controller {
  connect() {
    this.element.querySelectorAll("a").forEach(element => {
      element.addEventListener("click", this.scrollTo)
    })
  }

  scrollTo(event) {
    setTimeout(() => {
      const id = 'komentari'
      const target = document.getElementById(id)

      if (!target) {
        console.warn(`The element with the id: "${id}" does not exist on the page.`)
        return
      }

      const elementPosition = target.getBoundingClientRect().top + window.pageYOffset
      const offsetPosition = elementPosition - 0

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
    }, 50);
  }
}
